import styled from 'styled-components';
import { FaBluetoothB } from 'react-icons/fa';
var GenericIconButton = styled.a.withConfig({
  displayName: "IconButtonstyles__GenericIconButton",
  componentId: "pantheon__wx1a3g-0"
})(["border:none;border-radius:50%;width:42px;height:42px;background-color:#454545;cursor:pointer;display:flex;& svg{margin:auto;}&:hover{background-color:#979797;}"]);
var ExampleIcon = styled(FaBluetoothB).attrs({
  color: "#f7f7f7",
  size: "calc(60%)"
}).withConfig({
  displayName: "IconButtonstyles__ExampleIcon",
  componentId: "pantheon__wx1a3g-1"
})([""]);
export { GenericIconButton, ExampleIcon };